
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import t from "@common/src/i18n/t";
import SwitchStatus from "@common/src/components/scope/switch-status/index.vue";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import { Table, TableRowsSelect } from "@common/src/utils/decorator";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import FileUpload from "@common/src/components/scope/file-upload/index.vue";
import DelegatePrint from "@/views/service/components/delegate-print.vue";
import MissPoint from "@/views/service/components/miss-print.vue";
import SettlementPrint from "@/views/service/components/settlement-print.vue";
import SettlementTablePrint from "@/views/service/components/settlement-table-print.vue";
import ShangHaiPrint from "@/views/service/components/shanghai-print.vue";
import _ from "lodash-es";

import { verifyMoney, isPositiveIntegerZero, partsQuantityRules } from "@common/src/utils/verify";
const base = namespace("base");
const service = namespace("service");
const setting = namespace("setting");
const store = namespace("store");
const finance = namespace("finance");
const app = namespace("app");
const user = namespace("user");
@Component({
  components: {
    StandardFlag,
    SwitchStatus,
    FileUpload,
    DelegatePrint,
    MissPoint,
    SettlementPrint,
    ShangHaiPrint,
    SettlementTablePrint
  }
})
@Table("loadListData")
@TableRowsSelect({
  warningMsg: t("v211030.please-template-print"),
  updateStatusFuncName: "confirmUpdateStatus",
  tableRefKey: "table"
})
export default class PrintTemplate extends Vue {
  @base.Action getDictionaryList;
  @service.Action getPrintStoreLogo;
  @setting.Action reorderingPrintTemplates;
  @setting.Action updatePrintTemplateStatus;
  @setting.Action getPatternPaymentList;
  @setting.Action queryPrintFieldListByCode;
  @setting.Action savePrintFieldSet;
  @store.State storeData;
  @finance.Action getReceiptDetail;
  @app.State btnLoading;
  @setting.Action queryPrintTemplates;
  @setting.Action setPrintTemplateStoreLogo;
  @user.State u8cStore;
  @base.Action jumpPrintPage;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  t = t;
  keyword: string = "";
  serviceList: any[] = [];
  cardTemplateList: any[] = [];
  checked: boolean = false;
  showLogoEdit: boolean = false;
  showShangHaiPrint: boolean = false;
  missPointFlag: boolean = false;
  showPreviewPrint: boolean = false;
  showDelegatePrint: boolean = false;
  showFieldSetting: boolean = false;
  refreshFlag: boolean = true;
  orderDataFake = {};
  shanghaiPrint = {};
  detailDataFake = {};
  detailDataPrint: any = {
    orderStatus: "9",
    photoList: [],
    allOrderDetail: { service: [], parts: [], additional: [], receiptData: {} }
  };
  detailData: any = {
    orderStatus: "9",
    photoList: [],
    action: { otherArray: [], mustDoArray: [], optionalArray: [], printArray: [] }
  };
  logoForm = {
    logoSelect: true,
    logoImage: "https://static.gtech.asia/static/speedbiz/speedbiz_logo.png"
  };
  logoFormRule = {
    logoSelect: [{ required: true, validator: this.logoRule, trigger: "blur" }]
  };
  defaultTemplate: any[] = [];
  //计算属性
  get breadData() {
    return [];
  }
  logoImgRule(value, callback) {
    if (this.logoForm.logoImage) {
      callback();
    } else {
      callback(new Error(t("v270.please-upload-the-logo")));
    }
  }
  logoRule(rule, value, callback) {
    if (value === false) {
      this.logoImgRule(value, callback);
    } else {
      callback();
    }
  }
  created() {
    this.init();
  }
  printFieldList: any = [];

  async init() {
    this.loadListData();
  }
  getLogoImg() {
    this.getPrintStoreLogo().then(res => {
      this.logoForm.logoSelect = res.data.isDefaultLogo;
      this.logoForm.logoImage = res.data.storeLogo;
      if (!res.data.isDefaultLogo) {
        this.defaultTemplate = [
          {
            url: res.data.storeLogo
          }
        ];
      }
    });
  }
  @TableRowsSelect.updateMethod
  confirmUpdateStatus(status, selectedRow?) {
    return this.updatePrintTemplateStatus({
      status: status,
      printTemplateCode: selectedRow.printTemplateCode
    })
      .then(() => {
        this.$message.success(
          status === 1 ? (t("setting.enable-successful") as string) : (t("setting.disable-success") as string)
        );
        this.checked = false;
        this.loadListData();
      })
      .catch(e => {
        if (e.code === "speedbiz.system.pay-method-least-one-valid") {
          this.$message.error(t("setting.valid-method-payment"));
        }
      });
  }
  handleSearch() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryPrintTemplates({
      printTemplateName: this.keyword || "",
      printTemplateCode: ""
    }).then(data => {
      this.cardTemplateList = data.data.filter(
        item => !this.u8cStore || item.printTemplateCode !== "PRINT_PAYMENT_CREDENTIALS_THREE_TABLE"
      );
      return data;
    });
  }
  receiveServicePhone: string = "";

  receiveFieldList: any = null;
  viewRow: any = {};
  handleView(row) {
    if (row.category === "PRINT_SELECTED") {
      // 避单打印
      this.showPreviewPrint = true;
      this.orderDataFake = row.pseudoData;
    } else if (row.category === "PRINT_SHANGHAI_REPAIR") {
      // 上海维修打印
      this.showShangHaiPrint = true;
      this.shanghaiPrint = row.pseudoData;
    } else if (row.category === "PRINT_PAYMENT_CREDENTIALS") {
      // 结算单
      // this.jumpPrintPage({
      //   category: "PRINT_PAYMENT_CREDENTIALS",
      //   documentNo: "WB0825100175432"
      // });
      if (row.printTemplateCode === "PRINT_PAYMENT_CREDENTIALS_THREE_TABLE") {
        this.orderDataFake = row.pseudoData;
        this.showSettlementTable = true;
      } else {
        this.showPreviewPrint = true;
        row.pseudoData.customerNotice = row.customerNotice;
        this.orderDataFake = row.pseudoData;
        this.receiveServicePhone = row.templateServicePhone;
        this.receiveFieldList = row.printFieldList;
      }
    } else if (row.category === "PRINT_DELEGATION_CREDENTIALS") {
      // 委托
      this.detailDataFake = row.pseudoData;
      row.pseudoData.customerNotice = row.customerNotice;
      this.showDelegatePrint = true;
      this.receiveFieldList = row.printFieldList;
    }
    this.viewRow = row;
    this.refreshTemplate();
  }
  handleShowFieldSetting(row) {
    this.otherSettingForm = row;
    this.showFieldSetting = true;
    this.queryPrintFieldListByCode({ printTemplateCode: row.printTemplateCode }).then(data => {
      this.printFieldList = data.data?.printFieldList || [];
      if (data.data.templateServicePhone) {
        this.otherSettingForm = _.pick(data.data, Object.keys(this.otherSettingForm));
      }
    });
  }
  selectAll() {
    let ref = this.$refs["table"] as any;
    ref.toggleAllSelection();
  }
  changeSelect(selection) {
    if (selection.length === this.cardTemplateList.length) {
      this.checked = true;
    } else {
      this.checked = false;
    }
  }
  submitForm() {
    (this.$refs["logoForm"] as any).validate(valid => {
      if (valid) {
        this.setPrintTemplateStoreLogo({
          storeLogo: this.logoForm.logoImage,
          isDefaultLogo: this.logoForm.logoSelect
        }).then(res => {
          if (res.code === "0") {
            this.$message.success(t("v270.after-saving-successfully-you-can-click-the-template"));
            this.showLogoEdit = false;
          }
        });
      }
    });
  }
  checkAddData(): boolean {
    for (let i = 0; i < this.detailDataPrint.serviceDetail.length; i++) {
      if (!this.detailDataPrint.serviceDetail[i].serviceCode) {
        this.$message.warning(t("v210801.pls-select-project"));
        return false;
      }
      if (!this.detailDataPrint.serviceDetail[i].technicianCode.length) {
        this.$message.warning(t("v210831.please-select-a"));
        return false;
      }
      if (!this.detailDataPrint.serviceDetail[i].amount) {
        this.$message.warning(t("v210831.please-enter-the-work-group-fee"));
        return false;
      }
      if (!verifyMoney(this.detailDataPrint.serviceDetail[i].amount)) {
        this.$message.warning(t("v210831.please-enter-correct-worker-fee"));
        return false;
      }
      if (!isPositiveIntegerZero(this.detailDataPrint.serviceDetail[i].workingHours)) {
        this.$message.warning(t("v210831.please-enter-positive-integer-or-zero"));
        return false;
      }
    }
    for (let i = 0; i < this.detailDataPrint.partsDetail.length; i++) {
      if (!this.detailDataPrint.partsDetail[i].partsCode) {
        this.$message.warning(t("setting.select-spare-parts"));
        return false;
      }

      if (!this.detailDataPrint.partsDetail[i].sellingPrice) {
        this.$message.warning(t("v210831.please-enter-unit"));
        return false;
      }
      if (!verifyMoney(this.detailDataPrint.partsDetail[i].sellingPrice)) {
        this.$message.warning(t("v210831.please-enter-positive-integer-or-float"));
        return false;
      }
      if (!this.detailDataPrint.partsDetail[i].quantity) {
        this.$message.warning(t("v210831.please-enter-quantity"));
        return false;
      }
      if (!partsQuantityRules(this.detailDataPrint.partsDetail[i].quantity)) {
        this.$message.warning(t("v210831.please-input-the"));
        return false;
      }
    }
    return true;
  }
  queryAllOrderDipatch() {
    const service = [];
    const parts = [];
    const additional = [];
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    return this.getReceiptDetail({
      receiptNo: this.detailDataPrint.receiptNo,
      pageSize: 999,
      pageNum: 1
    }).then(
      async () => {
        this.detailDataPrint.serviceDetail.forEach(item => {
          item.technicianArray = item.technicianCode.map(item => {
            return {
              ...item,
              technicianCode: item.userCode || item.technicianCode,
              technicianName: item.staffName || item.technicianName
            };
          });
        });
        service.push(...this.detailDataPrint.serviceDetail);
        parts.push(...this.detailDataPrint.partsDetail);
        additional.push({
          additionalFees: this.detailDataPrint.additionalFees,
          additionalFeesRemark: this.detailDataPrint.additionalFeesRemark
        });
        loading.close();
        if (this.detailDataPrint.paymentList.length) {
          // 把避单金额加到第一个支付方式上
          this.detailDataPrint.paymentList[0].paidAmount = this.detailDataPrint.receiptAmount;
          this.detailDataPrint.paymentList = [this.detailDataPrint.paymentList[0]];
        } else {
          // 没有支付方式，默认方法
          this.detailDataPrint.paymentList = [
            {
              paidAmount: this.detailDataPrint.receiptAmount,
              paidMethod: "3",
              paidMethodDesc: t("service.wechat-pay")
            }
          ];
        }
        this.detailDataPrint = {
          ...this.detailDataPrint,
          allOrderDetail: { service, parts, additional, receiptData: this.detailDataPrint }
        };
      },
      () => {
        loading.close();
      }
    );
  }
  showLogoEditFn() {
    this.showLogoEdit = true;
    this.getLogoImg();
  }
  changeRadio() {
    (this.$refs.logoForm as any).clearValidate();
  }
  handleSaveFieldSetting() {
    (this.$refs.otherSettingForm as any).validate(valid => {
      if (valid) {
        if (this.otherSettingForm.storeNameSource === "CUSTOM" && !this.otherSettingForm.storeName) {
          this.$message.error(t("v216_6.please-input-store-name"));
        } else {
          this.handleSavePrintFieldSet();
        }
      }
    });
  }
  handleSavePrintFieldSet() {
    this.savePrintFieldSet({
      ...this.otherSettingForm,
      printFieldList: this.printFieldList,
      templateCode: this.otherSettingForm.printTemplateCode
    }).then(() => {
      this.$message.success(t("v210831.saved-successfully"));
      this.init();
      // 保存后刷新模板
      this.refreshTemplate();
      this.showFieldSetting = false;
    });
  }
  refreshTemplate() {
    this.refreshFlag = false;
    this.$nextTick(() => {
      this.refreshFlag = true;
    });
  }
  otherSettingForm: any = {
    templateServicePhone: "",
    customerNotice: "",
    storeNameSource: "STORE_NAME"
  };
  otherSettingFormRules: any = {
    templateServicePhone: {
      required: true,
      message: t("v213.please-enter-contact-information"),
      trigger: "blur"
    },
    storeNameSource: {
      required: true,
      message: t("v216_6.please-select-the-store-name-display-field"),
      trigger: "change"
    }
  };
  showSettlementTable = false;
  handleFieldChange(item) {
    const mutexList = item.selectMutexList;
    if (mutexList?.length) {
      this.printFieldList.forEach(item => {
        if (mutexList.includes(item.fieldCode)) {
          item.status = "0";
        }
      });
    }
  }
  handleStoreNameShowChange() {
    this.otherSettingForm.storeName =
      this.otherSettingForm.storeNameSource === "STORE_NAME"
        ? this.storeData.storeName
        : this.otherSettingForm?.storeNameSource === "BUSINESS_REGISTRATION_NAME"
        ? this.storeData.k2Name || "-"
        : "";
  }
}
